<template lang="pug">
  validation-observer(ref='observer' tag='form')
    header
      main-header
    .content-route-view
      el-card.card
        h1(v-if="!isEdicao") Cadastro de usuário
        h1(v-else) Edição de usuário
        el-row.margin-top( type="flex", justify="start")
          el-radio-group(v-if="!tipoChanged" v-model="setPessoaTipo" :disabled="isEdicao")
            el-radio-button(label='PF') Pessoa Física
            el-radio-button(label='PJ') Pessoa Jurídica
        app-divider(
          v-if="!isEdicao && !isExterno"
          label="Dados do usuário"
        )

        el-row.margin-top-15(v-if="!isEdicao && !isExterno")
          el-col(:span="12")
            app-input-perfil(v-model="usuario.perfis", :usuarioTipo="pessoa.tipo")

        el-row
          app-divider(
            :label="pessoa.tipo == 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'"
          )

        el-row.margin-top-15(
          :gutter="30",
          type="flex",
          v-if="pessoa.tipo === 'PF'",
          key="pessoaFisica"
        )
          el-col(:span="12")
            validation-provider(mode="lazy", rules="required|cpf_cnpj", v-slot="{ errors }", name="cadastroUsuario/cpf")
              app-label(
                label="CPF:",
                :required="true"
              )
              el-input.input(
                v-mask="['###.###.###-##']",
                :class="{'erro' : errors.length}",
                v-model="pessoa.pessoaFisica.cpf",
                @blur="buscarDados",
                suffix-icon="el-icon-search"
                :disabled="isEdicao"
              )
              span.help.erro {{ errors[0] }}
          el-col(:span="12")
            validation-provider(mode="lazy", rules="required", v-slot="{ errors }", name="cadastroUsuario/nome")
              app-label(
                label="Nome:",
                :required="true"
              )
              el-input.input(
                v-model="pessoa.pessoaFisica.nome",
                @input="input => pessoa.pessoaFisica.nome = input.toUpperCase()"
                :class="{'erro' : errors.length}",
                :maxlength="maxLengthNome"
              )
              span.help.erro {{ errors[0] }}
        el-row.margin-top-15(
          :gutter="30",
          type="flex",
          v-else,
          key="pessoaJuridica"
        )
          el-col(:span="12")
            validation-provider(mode="lazy", rules="required|cpf_cnpj", v-slot="{ errors }", name="cadastroUsuario/cnpj")
              app-label(
                label="CNPJ:",
                :required="true"
              )
              el-input.input(
                v-mask="['##.###.###/####-##']",
                v-model="pessoa.pessoaJuridica.cnpj",
                :class="{'erro' : errors.length}",
                @blur="buscarDados",
                suffix-icon="el-icon-search"
              )
              span.help.erro {{ errors[0] }}
          el-col(:span="12")
            validation-provider(mode="lazy", rules="required", v-slot="{ errors }", name="cadastroUsuario/razaoSocial")
              app-label(
                label="Razão Social:",
                :required="true"
              )
              el-input.input(
                v-model="pessoa.pessoaJuridica.razaoSocial",
                @input="input => pessoa.pessoaJuridica.razaoSocial = input.toUpperCase()"
                :class="{'erro' : errors.length}",
                :maxlength="maxLengthRazaoSocial",
              )
              span.help.erro {{ errors[0] }}
        el-row.margin-top-15(:gutter="30")
          el-col(:span="12")
            validation-provider(mode="lazy", rules="required|email", v-slot="{ errors }", name="cadastroUsuario/email")
              app-label(
                label="E-mail:",
                :required="true"
              )
              el-input.input(
                v-model="pessoa.email",
                :class="{'erro' : errors.length}",
                :disabled="isEdicao",
                :maxlength="maxLengthEmail",
              )
              span.help.erro {{ errors[0] }}
          el-col(:span="12")
            validation-provider(mode="lazy", rules="required|email_confirmation:@cadastroUsuario/email", v-slot="{ errors }", name="cadastroUsuario/emailConfirmacao")
              app-label(
                label="Confirmar e-mail:",
                :required="true"
              )
              el-input.input(
                v-model="pessoa.confirmaEmail",
                :class="{'erro' : errors.length}",
                :disabled="isEdicao",
                :maxlength="maxLengthEmail",
              )
              span.help.erro {{ errors[0] }}

        el-row.margin-top-15(:gutter="30")
          el-col(:span="12")
            app-input-telefone(
              :telefones="usuario.pessoa.telefones",
              :requiredTelefones="true",
              :nomeAba="isEdicao ? 'editUser' : 'createUser'",
              :observer="this.$refs.observer"
            )
        app-endereco(:endereco="usuario.pessoa.endereco" nomeAba="cadastroUsuario", :disabledFields="isUsuarioInterno()")
        el-row.margin-top(type="flex", justify="end")
          el-button(type='default', @click="cancelar()")
            | Cancelar
          el-button(type='primary', @click="cadastrar()")
            | {{!isEdicao ? 'Cadastrar' : 'Salvar'}}

</template>

<script>
import { mapActions } from 'vuex'

export default {

  components: {

  },

  mixins: [
  ],

  data () {
    return {
      maxLengthRazaoSocial: 200,
      maxLengthEmail: 200,
      maxLengthNome: 300,

      tipoChanged: false,
      isEdicao: false,

      usuario: {
        pessoa: {
          tipo: 'PF',
          pessoaFisica: {
            nome: '',
            cpf: ''
          },
          pessoaJuridica: {
            razaoSocial: '',
            cnpj: ''
          },
          endereco: {
            logradouro: '',
            numero: null,
            semNumero: false,
            complemento: '',
            bairro: '',
            cep: '',
            municipio: {
              id: '',
              codigoEstado: ''
            }
          },
          email: '',
          confirmaEmail: '',
          telefones: []
        },
        perfis: []
      }
    }
  },

  async mounted () {
    if (this.$route.params.cpfCnpj) {
      this.usuario = await this.findUsuarioByCpfCnpj(this.$route.params.cpfCnpj)
      this.usuario.pessoa.telefones = this.usuario.pessoa.telefones.map(item => item.numero)
      this.usuario.pessoa.confirmaEmail = this.usuario.pessoa.email

      this.isEdicao = true
    } else {
      this.usuario.pessoa.telefones = []
    }
  },

  computed: {

    isExterno () {
      return this.$route.params.tipo === 'externo'
    },

    pessoa () {
      return this.usuario.pessoa
    },

    isPessoaJuridica () {
      return this.pessoa.tipo === 'PJ'
    },

    isPessoaFisica () {
      return this.pessoa.tipo === 'PF'
    },

    setPessoaTipo: {
      get () {
        return this.pessoa.tipo
      },
      set (value) {
        this.tipoChanged = true
        this.confirmBox(this.$messages.CADASTRO_ALTERAR_TIPO_PESSOA, this.$messages.TITULO_WARNING,
          async () => {
            if (value === 'PJ') {
              this.pessoa.pessoaFisica.cpf = ''
              this.pessoa.pessoaFisica.nome = ''
            } else {
              this.pessoa.pessoaJuridica.cnpj = ''
              this.pessoa.pessoaJuridica.razaoSocial = ''
            }
            this.pessoa.email = ''
            this.pessoa.confirmaEmail = ''
            this.pessoa.tipo = value
            this.tipoChanged = false
            this.$refs.observer.reset()
          },
          () => { this.tipoChanged = false }
        )
      }
    }
  },

  methods: {

    ...mapActions({
      cadastrarUsuario: 'usuario/cadastrarUsuario',
      findUsuarioByCpfCnpj: 'usuario/findUsuarioByCpfCnpj'
    }),

    async buscarDados () {
      const cpfCnpj = this.usuario.pessoa.tipo === 'PF' ? this.usuario.pessoa.pessoaFisica.cpf
        : this.usuario.pessoa.pessoaJuridica.cnpj

      if (cpfCnpj) {
        const result = await this.findUsuarioByCpfCnpj(cpfCnpj)

        if (result) {
          if (this.usuario.pessoa.tipo === 'PF') {
            this.usuario.pessoa.pessoaFisica.cpf = ''
          } else {
            this.usuario.pessoa.pessoaJuridica.cnpj = ''
          }

          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            'O usuário já está cadastrado.'
          )
          this.$refs.observer.reset()
        }
      }
    },

    async cadastrar () {
      // Atenção: workaround para contornar problema na validação do componente de telefone.
      delete this.$refs.observer.refs['$ignoreTelefone$']

      if (await this.$refs.observer.validate()) {
        this.usuario.pessoa.telefones = this.usuario.pessoa.telefones.map(item => ({ numero: item }))

        if (!this.isEdicao) {
          this.confirmBox(this.$messages.FINALIZAR_CADASTRO_USUARIO, this.$messages.TITULO_WARNING,
            async () => {
              await this.cadastrarUsuario({ usuario: this.usuario, isExterno: this.isExterno })

              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.CADASTRO_USUARIO_SUCESSO
              )

              this.$router.push({
                name: this.isExterno ? 'login' : 'portalSeguranca/administradorAcesso'
              })
            },
            () => {}
          )
        } else {
          await this.cadastrarUsuario({ usuario: this.usuario, isExterno: this.isExterno })

          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.$messages.EDICAO_CADASTRO_SUCESSO
          )

          this.$router.push({
            name: 'portalSeguranca/administradorAcesso'
          })
        }
      } else {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.PREENCHA_TODOS_CAMPOS
        )
      }
    },

    cancelar () {
      this.confirmBox(this.$messages.CANCELAR_CADASTRO, this.$messages.TITULO_WARNING,
        () => {
          this.$router.push({
            name: this.isExterno ? 'login' : 'portalSeguranca/administradorAcesso'
          })
        },
        () => {}
      )
    },

    isUsuarioInterno () {
      const codigoSetores = this.usuario.perfis.map(perfil => perfil.setor ? perfil.setor.codigo : '')
      return (!this.isEdicao || !codigoSetores.includes('EXTERNO')) && !this.isExterno
    }

  }
}

</script>

<style lang="scss">

.card {
  margin: 0 3%;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}

.margin-top-15 {
  margin-top: 15px;
}

.content-route-view {
  padding: 15px 40px;
}

</style>
